var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12L15.8571 12",
    stroke: "#666666",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1426 7.71387L15.4283 11.9996L11.1426 16.2853",
    stroke: "#666666",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2852 2.57129L18.8566 2.57129C19.3112 2.57129 19.7473 2.7519 20.0688 3.07339C20.3903 3.39488 20.5709 3.83092 20.5709 4.28557L20.5709 19.7141C20.5709 20.1688 20.3903 20.6048 20.0688 20.9263C19.7473 21.2478 19.3112 21.4284 18.8566 21.4284L10.2852 21.4284",
    stroke: "#666666",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.be39e0d94cc4aa5866d839c8255c5dce.svg";
export { ForwardRef as ReactComponent };